import PageTemplate from '@/presentation/uiBlocks/page/PageTemplate.vue'
import routesMap from '@/project/pages/routesMap'

const routes = Object.values(routesMap).map(page => ({
  path: page.route,
  name: page.name,
  component: page.component || PageTemplate,
  meta: {
    title: page.title,
    checkAuth: page.checkAuth,
    needAuth: page.needAuth,
    layoutName: page.layoutName,
    isModal: page.isModal,
    permission: page.permission || null,
  },
}))

export default routes
